module.exports = __webpack_public_path__ + "img/vehicleicon_camera.4ba53ceb.jpg";